<template>
	<div class="staff-edit">
		<div class="link-list">
			<a href="#account"><link-list-item title="アカウント情報"></link-list-item></a>
			<a href="#avatar"><link-list-item title="プロフィール写真"></link-list-item></a>
			<a href="#profile"><link-list-item title="自己紹介文"></link-list-item></a>
			<a href="#password"><link-list-item title="パスワード"></link-list-item></a>
		</div>

		<div id="account" class="mt-20 mb-10 tm section-title">アカウント情報</div>

		<div class="mb-10 tm">※必須項目</div>

		<div class="input-wrap">
			<div class="input-title">ログインID ※ <span class="loginid-notice">半角英数のみ。スペース不可</span></div>
			<div class="sv-field">
				<input type="text" class="sv-input" :class="{ 'is-danger': $utils.hasError(errors, 'loginId') }" v-model="loginId" placeholder="半角英数"/>
			</div>
			<span class="error-message" v-show="errors.loginId">{{ errors.loginId }}</span>
		</div>

		<div class="input-wrap">
			<div class="input-title require">名前（姓/名）</div>
			<div class="sv-field name-horizontal">
				<input type="text" class="sv-input" :class="{ 'is-danger': $utils.hasError(errors, 'nameSei') }" v-model="nameSei"/>
				<input type="text" class="sv-input" :class="{ 'is-danger': $utils.hasError(errors, 'nameMei') }" v-model="nameMei"/>
			</div>
			<div class="error-message" v-show="errors.nameSei">（姓）{{ errors.nameSei }}</div>
			<div class="error-message" v-show="errors.nameMei">（名）{{ errors.nameMei }}</div>
		</div>

		<div class="input-wrap">
			<div class="input-title require">フリガナ（セイ/メイ）</div>
			<div class="sv-field name-horizontal">
				<input type="text" class="sv-input" :class="{ 'is-danger': $utils.hasError(errors, 'nameSeiKana') }" v-model="nameSeiKana"/>
				<input type="text" class="sv-input" :class="{ 'is-danger': $utils.hasError(errors, 'nameMeiKana') }" v-model="nameMeiKana"/>
			</div>
			<div class="error-message" v-show="errors.nameSeiKana">（セイ）{{ errors.nameSeiKana }}</div>
			<div class="error-message" v-show="errors.nameMeiKana">（メイ）{{ errors.nameMeiKana }}</div>
		</div>

		<div class="input-wrap">
			<div class="input-title">所属</div>
			<div class="sv-field">
				<div class="team-select-button" @click="isTeamSelectModalActive = true">所属を選択する</div>
			</div>
		</div>

		<div class="input-wrap">
			<div class="input-title require">性別</div>
			<div class="sv-field">
				<radio-picker :options="genders" v-model="genderId"></radio-picker>
			</div>
		</div>

		<div class="input-wrap">
			<div class="input-title">生年月日（西暦/月/日）</div>
			<div class="sv-field">
				<date-select :dateProvided="birthday" :hasEmptyOption="true" :isTextShow="false" :years="years" @change="onBirthdayInut"></date-select>
			</div>
			<span class="error-message" v-show="errors.birthday">{{ errors.birthday }}</span>
		</div>

		<div class="input-wrap">
			<div class="input-title">メールアドレス</div>
			<div class="sv-field">
				<input type="text" class="sv-input" :class="{ 'is-danger': $utils.hasError(errors, 'email') }" v-model="email"/>
			</div>
			<span class="error-message" v-show="errors.email">{{ errors.email }}</span>
		</div>

		<div id="avatar" class="mt-30 tm section-title">プロフィール写真</div>

		<div class="input-wrap">
			<div class="input-title"></div>
			<div class="sv-field" style="text-align: center;">
				<img class="preview" :src="imageBase" v-show="!image" :style="{ 'max-width': previewW + 'px' }">
				<image-picker :isDeleteButtonShow="false" :previewUrl="image" :isLoading="isImageLoading" :previewW="previewW" @file-change="onImageChange"></image-picker>
			</div>
		</div>

		<div id="profile" class="mt-30 tm section-title">自己紹介文</div>

		<div class="input-wrap" v-for="(row, index) in staffProfiles" :key="index">
			<div class="input-title">{{ row.title}}</div>
			<div class="sv-field">
				<textarea class="sv-input textarea" v-model="row.body"></textarea>
			</div>
		</div>

		<horizontal-buttons class="mt-30" okButtonTitle="更新" :isOkButtonLoading="isSubmitLoading" @ok-click="submit" @cancel-click="$router.push({ name: 'my-page' })"></horizontal-buttons>


		<div id="password" class="mt-30 tm section-title">パスワード</div>

		<div class="input-wrap">
			<div class="input-title require">新しいパスワード</div>
			<div class="sv-field">
				<input v-if="isPasswordShow" type="text" :placeholder="$consts.PWD_PH" class="sv-input" :class="{ 'is-danger': $utils.hasError(errors, 'password') }" v-model="password"/>
				<input v-else type="password" :placeholder="$consts.PWD_PH" class="sv-input" :class="{ 'is-danger': $utils.hasError(errors, 'password') }" v-model="password"/>
			</div>
			<div class="error-message" v-show="errors.password">{{ errors.password }}</div>
			<sv-checkbox class="mt-10" v-model="isPasswordShow">パスワードを表示</sv-checkbox>
		</div>

		<div class="text-center mt-20">
			<b-button type="is-primary" rounded @click="onPasswordChangeClick">パスワード変更</b-button>
		</div>

		<b-modal :active.sync="isTeamSelectModalActive">
			<div class="team-select-modal">
				<div class="team-select-title bold18 mb-20">所属チームを選択してください</div>
				<div class="team-select">
					<div v-for="(row, index) in teams" :key="index">
						<div class="mb-10" v-if="!row.is_organizer">
							<b-checkbox v-model="staffTeamsTmp"
								:native-value="row.id">
								{{ row.name }}
							</b-checkbox>
						</div>
					</div>
				</div>

				<horizontal-buttons class="mt-30" okButtonTitle="更新" @ok-click="staffTeams = staffTeamsTmp; isTeamSelectModalActive = false" @cancel-click="staffTeamsTmp = staffTeams; isTeamSelectModalActive = false"></horizontal-buttons>
			</div>
		</b-modal>
	</div>
</template>

<script>
import DateSelect from '@/components/DateSelect'
import RadioPicker from '@/components/RadioPicker'
import SvCheckbox from '@/components/SvCheckbox'
import ImagePicker from '@/components/ImagePicker'
import HorizontalButtons from '@/components/HorizontalButtons'
import LinkListItem from '@/components/LinkListItem'

export default {
	name: 'StaffEdit',
	components: {
		DateSelect,
		SvCheckbox,
		RadioPicker,
		ImagePicker,
		HorizontalButtons,
		LinkListItem,
	},
	data () {
		return {
			nameSei: '',
			nameMei: '',
			nameSeiKana: '',
			nameMeiKana: '',
			email: '',
			loginId: '',
			password: '',
			genderId: 1,
			birthday: '',
			isPasswordShow: false,
			isImageLoading: false,
			isSubmitLoading: false,
			isTeamSelectModalActive: false,
			errors: {
				nameSei: '',
				nameMei: '',
				nameSeiKana: '',
				nameMeiKana: '',
				email: '',
				loginId: '',
				password: '',
				birthday: '',
			},
			genders: null,
			teams: [],
			years: [],
			staffTeams: [],
			staffTeamsTmp: [],
			staffProfiles: [],
			image: '',
			imageBase: '',
			previewW: 160,
		}
	},
	created() {
	},
	mounted() {
		this.years = this.$utils.createYearSelectOption();
		this.init();
	},
	methods: {
		onPasswordChangeClick: async function() {
			for (let key in this.errors) {
				this.errors[key] = '';
			}

			this.isPasswordLoading = true;
			let data = {
				"password": this.password,
			};
			this.$utils.log(data);

			let ep = 'staffs/password/' + this.id;
			this.$utils.log(ep);

			try {
				let res = await this.$api.patch(ep, data, true);
				this.$utils.log(res);
				this.$router.push({ name: 'my-page' });
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
				if (error.response.status === 400) {
					let details = error.response.data.details;
					for (let key in details) {
						this.errors[this.$utils.toCamelCase(key)] = details[key];
					}
				}
			} finally {
				this.isPasswordLoading = false;
			}
		},
		submit: async function() {
			for (let key in this.errors) {
				this.errors[key] = '';
			}

			this.isSubmitLoading = true;
			let data = {
				"name_sei": this.nameSei,
				"name_mei": this.nameMei,
				"name_sei_kana": this.nameSeiKana,
				"name_mei_kana": this.nameMeiKana,
				"gender_id": this.genderId,
				"birthday": this.birthday,
				"email": this.email,
				"login_id": this.loginId,
				"avatar_main": this.image,
				"staff_profiles": this.staffProfiles,
				"staff_teams": this.staffTeams,
			};
			this.$utils.log(data);

			let ep = 'staffs/' + this.id;
			this.$utils.log(ep);

			try {
				let res = await this.$api.patch(ep, data, true);
				this.$utils.log(res);
				this.$router.push({ name: 'my-page' });
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
				if (error.response.status === 400) {
					let details = error.response.data.details;
					for (let key in details) {
						this.errors[this.$utils.toCamelCase(key)] = details[key];
					}
				}
			} finally {
				this.isSubmitLoading = false;
			}
		},
		onImageChange: function(file) {
			this.uploadImage(file);
		},
		uploadImage: async function(file) {
			this.isImageLoading = true;

			let data = {
				"image": file,
			};
			let ep = 'staffs/avatar';

			try {
				let res = await this.$api.post(ep, data);
				this.$utils.log(res);
				this.image = res.data.url;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isImageLoading = false;
			}
		},
		onBirthdayInut: function(date) {
			this.birthday = date;
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			let loader = this.$buefy.loading.open();
			let ep = 'staffs/screen-for-edit';
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.id = res.data.id;
				this.nameSei = res.data.name_sei;
				this.nameMei = res.data.name_mei;
				this.nameSeiKana = res.data.name_sei_kana;
				this.nameMeiKana = res.data.name_mei_kana;
				this.email = res.data.email;
				this.loginId = res.data.login_id;
				this.imageBase = res.data.image_base;
				this.image = res.data.image;
				this.genderId = res.data.gender_id;
				this.birthday = res.data.birthday;
				this.genders = res.data.genders;
				this.teams = res.data.teams;
				this.staffTeams = res.data.staff_teams;
				this.staffTeamsTmp = res.data.staff_teams;
				this.staffProfiles = res.data.staff_profiles;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
	}
}
</script>

<style lang="scss" scoped>
@import '@/scss/_vars.scss';

.staff-edit {
	font-size: 18px;

	.preview {
		display: block;
		margin: 0 auto;
	}

	/deep/ .link-list-item {
		background: #fff;
		border: $commonBorder;
	}
	/deep/ .link-list a:not(:last-child) .link-list-item {
		border-bottom: none;
	}

	.team-select-button {
		padding: 12px;
		background: #fff;
		border: $commonBorder;
	}

	.modal-content {
		width: $modalW;
		max-width: $modalMaxW;
		border-radius: 10px;
		height: 300px;

		div.team-select {
			height: 300px;
			overflow: scroll;
		}

		.team-select-modal {
			background: #fff;
			padding: 25px 30px;

			.team-select-title {
				text-align: center;
			}
		}
	}
}

@media screen and (min-width: $breakPoint) {
	$sideMargin: 120px;

	.link-list {
		display: none;
	}

	.staff-edit {
		margin-left: $sideMargin;
		margin-right: $sideMargin;
	}
}

</style>
